import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-current-trip',
  templateUrl: './mcommerce-current-trip.component.html',
  styleUrls: ['./mcommerce-current-trip.component.scss']
})
export class McommerceCurrentTripComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
